import React from 'react';

const ThreeColumnGrid = ({ children }) => (
  <div className="lg:grid-cols-3 md:grid-cols-2 grid grid-cols-1 gap-8">
    {children}
  </div>
);

export default ThreeColumnGrid;
